import {Card, DataStatus, Separator} from 'platform/components';
import {Grid, Heading, VStack} from 'platform/foundation';

import {useGetCustomerContractBasicInformationQuery} from '@dms/api/customer';
import i18n from '@dms/i18n';

import {TestIdProps, suffixTestId} from 'shared/web';

import {DiscountAttributes} from '../../DiscountAttributes/DiscountAttributes';
import {SummaryItem} from '../../SummaryItem/SummaryItem';

interface ContractBasicInfoSectionProps extends TestIdProps {
  customerContractId: string;
}

export function ContractBasicInfoSection(props: ContractBasicInfoSectionProps) {
  const {data, isLoading, isError} = useGetCustomerContractBasicInformationQuery({
    customerContractId: props.customerContractId,
  });

  return (
    <Card title={i18n.t('general.labels.basicInformation')}>
      <DataStatus isLoading={isLoading} isError={isError} minHeight={50}>
        <VStack spacing={4}>
          <Grid columns={4}>
            <SummaryItem
              isAlternative
              title={i18n.t('general.labels.name')}
              value={data?.name}
              data-testid={suffixTestId('name', props)}
            />
            <SummaryItem
              isAlternative
              title={i18n.t('general.labels.description')}
              value={data?.description}
              data-testid={suffixTestId('description', props)}
            />
            <SummaryItem
              isAlternative
              title={i18n.t('entity.order.labels.customerGroupForMaterialDelivery')}
              value={data?.materialDiscountGroup?.name}
              data-testid={suffixTestId('customerGroup', props)}
            />
          </Grid>
          <Separator spacing={0} />
          <Heading size={5}>{i18n.t('entity.workshopCustomerGroup.labels.customerGroups')}</Heading>
          <DiscountAttributes
            groupId={data?.materialDiscountGroup?.id}
            size="gridQuarter"
            data-testid={suffixTestId('discounts', props)}
          />
        </VStack>
      </DataStatus>
    </Card>
  );
}
